export default __webpack_public_path__ + "static/media/logoNovusDark.fc171818.png";